export default __webpack_public_path__ + "static/media/Sports & Athleisure 2.087adeff.jpg";